import { RootAction, FeedActions } from '../actions';
import dayjs from 'dayjs';
import { Loadable } from '@tradingblock/types';

import { SpreadSymbolSpreads, SpreadsState } from '../state';
import { InitialState } from '../initialState';
import { getType } from 'typesafe-actions';

import { SymbolChangeDirection, getLocalDateFromTimezone, SymbolSpreadAndChangeData } from '@tradingblock/api';
import _ from 'lodash';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const numOrZero = <T>(...values: (T | undefined)[]) => {
  const firstNonNil = _.find(values, v => !_.isNil(v) && !_.isNaN(v));
  return _.isNil(firstNonNil) ? 0 : firstNonNil;
};

export const spreadReducer = (state = InitialState.spread, action: RootAction): SpreadsState => {
  switch (action.type) {
    case getType(FeedActions.updateSpreads): {
      const { spreads } = action.payload;
      const symbolDataAsObject = _.reduce(
        spreads,
        (acc: SpreadSymbolSpreads, v, k) => {
          const existingValue: Loadable<SymbolSpreadAndChangeData> | undefined = state.spreadMetadata.data[k];
          let existing = existingValue || { Symbol: k };

          const ask = numOrZero(v.Ask, existing.Ask);
          const bid = numOrZero(v.Bid, existing.Bid);
          const last = numOrZero(v.Last, existing.Last);
          const change = numOrZero(v.Change, existing.Change);
          const ReceivedTime = v.SpreadTime;
          let changeDirection: SymbolChangeDirection = undefined;
          if (existingValue && existingValue.Last > v.Last) {
            changeDirection = 'down';
          } else if (existingValue && existingValue.Last < v.Last) {
            changeDirection = 'up';
          }
          return {
            ...acc,
            [v.Symbol]: {
              ...existing,
              Ask: ask,
              Bid: bid,
              Last: last,
              Change: change,
              isLoaded: true,
              ReceivedTime,
              changeDirection,
            },
          };
        },
        state.spreadMetadata.data
      );
      const latestReceivedTime = _(symbolDataAsObject)
        .map((value, key) => {
          return getLocalDateFromTimezone(new Date(value.ReceivedTime)).valueOf();
        })
        .max();
      return {
        ...state,
        spreadMetadata: {
          ...state.spreadMetadata,
          isFetching: false,
          data: {
            ...symbolDataAsObject,
          },
          latestReceivedTime,
        },
      };
    }

    default:
      return state;
  }
};
